import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { ItemRestriction, OPERATORS } from 'typings'
import { SummaryRow, Tag, TagsListTruncate } from 'ui'
import { messages } from '../messages'

const CONTENT_MAX_WIDTH = 336

type Props = {
  salesChannels: ItemRestriction | undefined
}

export function SalesChannelsRow(props: Props) {
  const { salesChannels } = props

  const emptySalesChannels = !salesChannels?.items.length

  return (
    <SummaryRow>
      <SummaryRow.Title>
        <FormattedMessage
          {...messages.salesChannels.title}
          values={{
            isDifferent: salesChannels?.operator === OPERATORS.DIFFERENT,
            b: (content) => (content.length ? <Text>{content}</Text> : null),
          }}
        />
      </SummaryRow.Title>
      <SummaryRow.Value>
        {emptySalesChannels ? (
          <FormattedMessage {...messages.salesChannels.empty} />
        ) : (
          <TagsListTruncate
            maxWidth={CONTENT_MAX_WIDTH}
            content={salesChannels.items.map(({ name }) => name) ?? []}
          >
            {salesChannels.items.map(({ name }, index) => (
              <TagsListTruncate.Atom key={index}>
                <Tag>{name}</Tag>
              </TagsListTruncate.Atom>
            ))}
          </TagsListTruncate>
        )}
      </SummaryRow.Value>
    </SummaryRow>
  )
}
